/**
 * Resolves language aliases to their proper syntax highlighter names
 */
export const resolveLanguage = (language?: string): string => {
  // Default to luau and resolve lua to luau
  if (language === undefined || language === 'lua') {
    return 'luau';
  }
  // react-syntax-highlighter requires 'csharp' instead of 'cs'
  if (language === 'cs') {
    return 'csharp';
  }
  return language;
};

/**
 * Analyzes code content to determine display characteristics
 */
export interface ContentAnalysis {
  isMultiline: boolean;
  exceedsMaxHeight: boolean;
  numLines: number;
}

const CODE_LINE_HEIGHT = 25;

export const analyzeContent = (content: string, maxContentHeight: number): ContentAnalysis => {
  const numLines = content.split('\n').length;
  const approxNumLinesInView = Math.floor(maxContentHeight / CODE_LINE_HEIGHT);

  return {
    numLines,
    isMultiline: numLines > 1,
    exceedsMaxHeight: numLines > approxNumLinesInView,
  };
};
